import { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const translations = useMemo(() => {
    return {
      headingName: formatMessage(messages.headingName),
      headingType: formatMessage(messages.headingType),
      headingPrice: formatMessage(messages.headingPrice),
      headingAppliesTo: formatMessage(messages.headingAppliesTo),
      headingPrivate: formatMessage(messages.headingPrivate),
      privateTrue: formatMessage(messages.privateTrue),
      privateFalse: formatMessage(messages.privateFalse),
      typeStat: formatMessage(messages.typeStat),
      typeRequiresContactingPatient: formatMessage(
        messages.typeRequiresContactingPatient,
      ),
      btnArchive: formatMessage(messages.btnArchive),
      btnEdit: formatMessage(messages.btnEdit),
    };
  }, [formatMessage]);

  return translations;
};
export default useTranslations;
